module.exports = new __parcel__URL__("buckley-listening.b145c945.png").toString();